import { useTranslation } from 'react-i18next';

export const useCookiesInfo = () => {
  const { t } = useTranslation('common');
  const rootDomain = window.location.hostname.split('.').slice(-2).join('.');
  return [
    {
      name: 'sessionid',
      subgroup: `app.${rootDomain}`,
      lifespan: t('cookiepolicy.lifespan.session'),
      cookiesUsed: t('cookiepolicy.cookiesUsed.firstParty'),
      description: t('cookiepolicy.description.sessionIdentifierText'),
    },
    {
      name: 'accesstoken',
      subgroup: `iso.${rootDomain}`,
      lifespan: t('cookiepolicy.lifespan.aFewSeconds'),
      cookiesUsed: t('cookiepolicy.cookiesUsed.firstParty'),
      description: t('cookiepolicy.description.accessTokenText'),
    },
    {
      name: 'LangID',
      subgroup: `iso.${rootDomain}`,
      lifespan: t('cookiepolicy.lifespan.Days', { count: 30 }),
      cookiesUsed: t('cookiepolicy.cookiesUsed.firstParty'),
      description: t('cookiepolicy.description.languageText'),
    },
    {
      name: 'cookieConsentAccepted',
      subgroup: `iso.${rootDomain}`,
      lifespan: t('cookiepolicy.lifespan.Days', { count: 365 }),
      cookiesUsed: t('cookiepolicy.cookiesUsed.firstParty'),
      description: t('cookiepolicy.description.cookieConsentAcceptedText'),
    },
    {
      name: 'PHPSESSID',
      subgroup: `iso.${rootDomain}`,
      lifespan: t('cookiepolicy.lifespan.session'),
      cookiesUsed: t('cookiepolicy.cookiesUsed.firstParty'),
      description: t('cookiepolicy.description.sessionEmbeddedText'),
    },
    {
      name: 'jwt',
      subgroup: `iso.${rootDomain}`,
      lifespan: t('cookiepolicy.lifespan.session'),
      cookiesUsed: t('cookiepolicy.cookiesUsed.firstParty'),
      description: t('cookiepolicy.description.temporaryLoginCookieText'),
    },
  ];
};
